function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import FontAwesome from 'react-fontawesome';
import styled from 'styled-components';
var NavIcon = styled(function (_ref) {
  var className = _ref.className,
      fixedWidth = _ref.fixedWidth,
      font = _ref.font,
      name = _ref.name,
      passThroughProps = _objectWithoutProperties(_ref, ["className", "fixedWidth", "font", "name"]);

  if (font === 'flight') {
    return /*#__PURE__*/React.createElement("span", _extends({
      "aria-hidden": "true",
      className: "flight-icon flight-icon-".concat(name, " ").concat(className)
    }, passThroughProps));
  } else {
    return /*#__PURE__*/React.createElement(FontAwesome, _extends({
      className: className,
      fixedWidth: fixedWidth,
      name: name
    }, passThroughProps));
  }
}).withConfig({
  displayName: "NavIcon",
  componentId: "sc-1r6w3c-0"
})(["margin-right:10px;"]);
export default NavIcon;